export const DESIGNATION_STATUS = {
  NOT_SUBMITTED: 'NotSubmitted',
  FORMED: 'Formed',
  APPROVED: 'Approved',
  TO_BE_SIGNED: 'ToBeSigned',
  SIGNED: 'Signed',
  CANCELLED: 'Cancelled'
};
